import React from 'react';
import { Navigate } from 'react-router-dom';
import jwt_decode from 'jwt-decode';

const ProtectedRoute = ({ allowedRoles, children }) => {
  // const user = JSON.parse(sessionStorage.getItem('ASIUser'));
  // const userRole = user?.userType;

  const roleToken = sessionStorage.getItem('accessLevel');
  const decodedToken = jwt_decode(roleToken);
  const userRole = decodedToken.role;
  console.log("Role from accessToken:", userRole);


  if (!userRole) {
    // Not logged in
    return <Navigate to="/login" replace />;
  }

  if (!allowedRoles.includes(userRole)) {
    // Role not allowed – redirect immediately
    // return <Navigate to="/404" replace />;
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default ProtectedRoute;
